var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysSearch = function SvgSysSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.145 13.853-3.834-3.84A4.494 4.494 0 0 1 3.157 9.5a4.494 4.494 0 0 1 .172-6.174 4.491 4.491 0 0 1 6.172-.17 4.49 4.49 0 0 1 .515 6.152l3.839 3.84a.504.504 0 0 1-.003.71.498.498 0 0 1-.707-.005ZM3 6.5a3.503 3.503 0 0 0 4.182 3.433A3.503 3.503 0 0 0 9.733 5.16 3.499 3.499 0 0 0 3 6.5Z"
  })));
};
export default SvgSysSearch;